import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

function sendRequest(checkBox, email) {
  if (!checkBox && !email) return true;
  return false;
}

const FormRequest = ({ header, subheader, placeholder, btncolor, _onChange,
  _onClick, btntext, extraActiontext, _onClickExtraAction, valNumber, valueCheckBox, _onChangeCheckBox,
  valueEmail, _onChangeEmail,
  pinForAuthorizeError }) => (
  <form onSubmit={(e) => { e.preventDefault(); if (sendRequest(valueCheckBox, valueEmail)) { _onClick(valNumber); } }}>
    <p>{header}</p>
    <p className="text-danger"><small>{subheader}</small></p>
    <input
      type="tel"
      className="form-control block"
      value={valNumber || ''}
      placeholder={placeholder}
      onChange={(e) => _onChange(e)}
      pattern="\d*"
    />
    <input
      className="contact-me-by-tel"
      type="checkbox"
      name="contact-me-by-tel-only"
      value={valueCheckBox || ''}
      onChange={(e) => _onChangeCheckBox(e)}
      tabIndex="-1"
      autoComplete="off"
    />
    <input
      className="input-email"
      type="email"
      name="email"
      value={valueEmail || ''}
      onChange={(e) => _onChangeEmail(e)}
    />
    {
      pinForAuthorizeError
      && (
        <div className="noti-feedback">
          {pinForAuthorizeError.message}
        </div>
      )
    }
    <Button
      color={btncolor}
      block
      onClick={() => { if (sendRequest(valueCheckBox, valueEmail)) { _onClick(valNumber); } }}
    >
      {btntext}
    </Button>
    {
      extraActiontext
      && (
        <Button
          color="link"
          onClick={() => _onClickExtraAction('renew')}
        >
          {extraActiontext}
        </Button>)
    }
  </form>
);

FormRequest.defaultProps = {
  extraActiontext: null,
  _onClickExtraAction: () => { },
  valNumber: [''],
  pinForAuthorizeError: null
};

FormRequest.propTypes = {
  _onChange: PropTypes.func.isRequired,
  _onClick: PropTypes.func.isRequired,
  _onClickExtraAction: PropTypes.func,
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  btncolor: PropTypes.string.isRequired,
  btntext: PropTypes.string.isRequired,
  extraActiontext: PropTypes.string,
  valNumber: PropTypes.array,
  pinForAuthorizeError: PropTypes.object,
  valueCheckBox: PropTypes.bool.isRequired,
  _onChangeCheckBox: PropTypes.func.isRequired,
  valueEmail: PropTypes.string.isRequired,
  _onChangeEmail: PropTypes.func.isRequired
};

export default FormRequest;



// WEBPACK FOOTER //
// ./src/components/ManualAccesComponents/FormRequest.js